import React from 'react';
import { Chip } from '@mui/material';

/**
 * Shared status chip for attendance rows. `AttendanceList` and `EmployeeAttendanceList` each had
 * a byte-identical local copy of this (`StatusChip` / `EmployeeStatusChip`) — lifted here once
 * (Task 15) so there is a single definition to keep in sync.
 */
const AttendanceStatusChip = ({ status }: { status: string }) => {
    const color = status === 'Present' ? 'success'
        : status === 'Absent' ? 'error'
        : status.startsWith('Holiday') ? 'warning'
        : 'default';
    return <Chip label={status} size="small" color={color} variant="outlined" />;
};

export default AttendanceStatusChip;
